/**
 * Geometría de los 32 estados de México (GeoJSON) y emparejamiento de nombres
 * de la dimensión "región" contra ese catálogo, para el widget de mapa.
 */
import mexicoStatesGeoJson from '../../../assets/geo/mexicoStates.json';

export const MEXICO_STATES_GEOJSON = mexicoStatesGeoJson;

// Marcas diacríticas combinantes (U+0300-U+036F) que deja `normalize('NFD')`.
const COMBINING_MARKS = /[̀-ͯ]/g;

/** Minúsculas, sin acentos, sin espacios sobrantes. */
export function normalizeStateName(raw) {
    return String(raw || '')
        .normalize('NFD')
        .replace(COMBINING_MARKS, '')
        .toLowerCase()
        .replace(/^estado de\s+/, '')
        .replace(/[.,]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

// Variantes comunes de captura que no matchean el nombre oficial por texto plano.
const STATE_ALIASES = {
    'cdmx': 'ciudad de mexico',
    'distrito federal': 'ciudad de mexico',
    'df': 'ciudad de mexico',
    'mexico df': 'ciudad de mexico',
    'mexico city': 'ciudad de mexico',
    'edomex': 'mexico',
    'estado de mexico': 'mexico',
    'state of mexico': 'mexico',
    'nl': 'nuevo leon',
    'bc': 'baja california',
    'bcs': 'baja california sur',
    'slp': 'san luis potosi',
    'qro': 'queretaro',
    'qroo': 'quintana roo',
    'ver': 'veracruz',
    'mich': 'michoacan',
    'yuc': 'yucatan',
    // Denominaciones oficiales largas (catálogo INEGI) de los 4 estados que la llevan.
    'coahuila de zaragoza': 'coahuila',
    'michoacan de ocampo': 'michoacan',
    'queretaro arteaga': 'queretaro',
    'queretaro de arteaga': 'queretaro',
    'veracruz de ignacio de la llave': 'veracruz',
    'veracruz llave': 'veracruz',
};

const STATES_BY_NORMALIZED_NAME = new Map(
    MEXICO_STATES_GEOJSON.features.map(feature => [normalizeStateName(feature.properties.name), feature])
);

/** Busca el estado del GeoJSON que corresponde a un valor crudo de la dimensión "región". */
export function matchStateFeature(rawValue) {
    const normalized = normalizeStateName(rawValue);
    if (!normalized) return { feature: null, matched: false };
    const resolved = STATE_ALIASES[normalized] || normalized;
    const feature = STATES_BY_NORMALIZED_NAME.get(resolved) || null;
    return { feature, matched: Boolean(feature) };
}
